/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TextBulletGroupIcon32Regular = forwardRef('TextBulletGroupIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 8a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8Zm6 0H5v4h4V8Z" }),
        React.createElement("path", { d: "M15 6a1 1 0 1 0 0 2h12a1 1 0 1 0 0-2H15Z" }),
        React.createElement("path", { d: "M15 12a1 1 0 1 0 0 2h12a1 1 0 1 0 0-2H15Z" }),
        React.createElement("path", { d: "M15 24a1 1 0 1 0 0 2h12a1 1 0 1 0 0-2H15Z" }),
        React.createElement("path", { d: "M14 19a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H15a1 1 0 0 1-1-1Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 18a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2H5Zm0 2h4v4H5v-4Z" })));
});
